import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './header.css';
import { sendScreenAnalytics } from '../headerHelper';

const Header: React.FC = () => {
  const location = useLocation();

  const activeTab = (activePath: string): string => {
    if (location.pathname === activePath) {
      return 'menu-item-active';
    }
    return 'menu-item';
  };

  // For analytics
  useEffect(() => {
    sendScreenAnalytics(location.pathname)
      .then(() => {
        console.log('done');
      })
      .catch((err) => {
        console.error(err);
      });
  }, [location]);

  return (
    <div className="header">
      <div className="image">
        <img
          src="https://www.zonetail.com/wp-content/uploads/2018/09/Zonetail-Logo.svg"
          alt="Zonetail logo"
          width={135}
          height={30}
        />
      </div>
      <div className="links">
        <Link to="/" className={activeTab('/')}>
          Home
        </Link>
        <Link to="/explore" className={activeTab('/explore')}>
          Explore
        </Link>
        <Link to="/contact" className={activeTab('/contact')}>
          Contact
        </Link>
      </div>
    </div>
  );
};

export default Header;
